module.exports = __webpack_public_path__ + "static/media/mcyadra.70326a17.jpg";